/*
 * @Author: your name
 * @Date: 2021-05-17 09:29:53
 * @LastEditTime: 2022-09-15 18:52:36
 * @LastEditors: Smart Chow
 * @Description: In User Settings Edit
 * @FilePath: \nqc-pc-ui\src\frameworks\api\login.js
 */
import * as request from '@/frameworks/http/request'
import { apiService } from '@/frameworks/http/request'
import store from '@/frameworks/store/index'
// import sysConfig from "@/common/settings/systemSetting";

const prefix = 'NQCS/DoAction?act='

export function loginByUsername(username, password) {
  let data = {
    loginName: username,
    password
  }
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function getUserMenu(params) {
  params = { HospitalCode, ...params }
  return apiService({
    url: `${prefix}GetUserMenu`,
    method: 'post',
    data: params
  })
}
export function getLoginUserInfo(params) {
  return apiService({
    url: `${prefix}Login_nqes`,
    method: 'post',
    data: params
  })
}

export function getSystemParam(params) {
  let HospitalCode = store.state.user.HospitalCode
  params = { HospitalCode, Mjdm: '1127,1146,1151,1100,1193' }
  return apiService({
    url: `${prefix}GetXTMJList`,
    method: 'post',
    data: params
  })
}

export function getIsMulHospital(params) {
  params = {}
  return apiService({
    url: `${prefix}GetIsMulHospital`,
    method: 'post',
    data: params
  })
}
